/**
 * Uniba Banner reducer
 * @module src/reducers/unibaHeaderSlimConfigReducer
 */

import { GET_UNIBA_HEADERSLIM_CONFIG } from 'design-comuni-plone-theme/actions';

const initialState = {
  error: null,
  hasError: false,
  result: {},
  loadingResults: false,
};

export const unibaHeaderSlimConfigReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case `${GET_UNIBA_HEADERSLIM_CONFIG}_PENDING`:
      return {
        ...state,
        loadingResults: true,
      };

    case `${GET_UNIBA_HEADERSLIM_CONFIG}_SUCCESS`:
      return {
        ...state,
        result: action.result,
        loadingResults: false,
      };

    case `${GET_UNIBA_HEADERSLIM_CONFIG}_FAIL`:
      return {
        ...state,
        error: action.error,
        hasError: true,
        loadingResults: false,
      };

    default:
      return state;
  }
};
